// extracted by mini-css-extract-plugin
export default {"image":"HotelImages_image__3R8Sz"};